import { useQuery } from '@tanstack/react-query';

import getTalkingPointStatuses from 'Api/brief-live/getTalkingPointStatuses';

import getTalkingPointStatusesResponse from './model/response/getTalkingPointStatusesResponse';

const useGetTalkingPointStatuses = () => {
  return useQuery({
    queryKey: ['all-talking-point-statuses'],
    queryFn: async () => {
      const response = await getTalkingPointStatuses();

      const result = getTalkingPointStatusesResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 15 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};

export default useGetTalkingPointStatuses;
